import { defineComponent as _defineComponent } from 'vue'
import CcCard from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCard.ts.vue';
import CcError from '@/views/Automation/CampaignCreatorV2/components/CcError/CcError.ts.vue';
import TreeselectAccountOption from '@/views/Automation/CampaignCreatorV2/components/Treeselect/TreeselectAccountOption.ts.vue';
import useAdAccountStore from '@/views/Automation/CampaignCreatorV2/store/AdAccount';
import useCampaignStore from '@/views/Automation/CampaignCreatorV2/store/Campaign';
import Treeselect from '@riophae/vue-treeselect';
import { storeToRefs } from 'pinia';
import { computed, onMounted } from 'vue';
import { useTour } from '../../helpers/tourGuide';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdAccount.ts',
  setup(__props) {

const adAccountStore = useAdAccountStore();
const { getAdAccountsOptions } = storeToRefs(adAccountStore);
const campaignStore = useCampaignStore();
const { getField } = storeToRefs(campaignStore);

onMounted(() => {
  useTour('Campaign');
});

const accountOptions = computed(() =>
  getAdAccountsOptions.value?.map((account) => ({
    ...account,
    id: account.id,
    label: account.name,
    isActive: true,
    info: account.id,
  }))
);
const selectedAccount = computed(() => getField.value('account_id')?.value?.[0]?.value);

function onAccountChange(value: { id: number }) {
  campaignStore.addOrEditVariable('account_id', {
    field: 'account_id',
    value: value.id,
    variableId: 'account_id_var',
  });
  adAccountStore.prepareAccount(value.id);
}

return { __sfc: true,adAccountStore, getAdAccountsOptions, campaignStore, getField, accountOptions, selectedAccount, onAccountChange, CcCard, CcError, TreeselectAccountOption, Treeselect }
}

})